import React, { useState, useEffect } from "react";
import axios from "axios";

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/notifications`;

function AddNotifications() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [deleteDate, setDeleteDate] = useState("");
  const [sendTo, setSendTo] = useState("students");
  const [userId, setUserId] = useState(""); // Optional for specific user
  const [attachFile, setAttachFile] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
const [submitting, setSubmitting] = useState(false);
const [editId, setEditId] = useState(null);

  // Get current session + user info
  const currentSessionId = localStorage.getItem("currentSessionId");
  const role = localStorage.getItem("role") || "students";
  const loggedInUserId = localStorage.getItem("userId") || null;

  // Fetch notifications only for current session
 const fetchNotifications = async () => {
  if (!currentSessionId) return;
  try {
    setLoading(true);

    const res = await axios.get(`${API_BASE}/getNotification`, {
      params: {
        sessionId: currentSessionId,
      },
    });

    setNotifications(res.data);
  } catch (error) {
    console.error("Error fetching notifications:", error);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchNotifications();
  }, [currentSessionId]);
const handleEdit = (notification) => {
  setEditId(notification._id);
  setTitle(notification.title);
  setContent(notification.content);
  setDeleteDate(notification.deleteDate?.slice(0, 10));
  setSendTo(notification.sendTo);
  setUserId(notification.userId || "");
  setAttachFile(null); // file re-upload optional
};

  // Handle submission of new notification
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!title.trim() || !content.trim() || !deleteDate) {
    return alert("Please fill in all required fields.");
  }

  const formData = new FormData();
  formData.append("title", title);
  formData.append("content", content);
  formData.append("deleteDate", deleteDate);
  formData.append("sendTo", sendTo);
  formData.append("sessionId", currentSessionId);

  if (sendTo === "user" && userId) formData.append("userId", userId);
  if (attachFile) formData.append("attachFile", attachFile);

  // 🔥 KEY PART
  if (editId) {
    formData.append("notificationId", editId);
  }

  try {
    setSubmitting(true);

    await axios.post(`${API_BASE}/createNotification`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    alert(editId ? "Notification updated successfully!" : "Notification added successfully!");

    // Reset form
    setTitle("");
    setContent("");
    setDeleteDate("");
    setSendTo("students");
    setUserId("");
    setAttachFile(null);
    setEditId(null);

    fetchNotifications();
  } catch (error) {
    console.error("Error saving notification:", error);
    alert("Failed to save notification.");
  } finally {
    setSubmitting(false);
  }
};



  // Handle delete
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this notification?")) return;
    try {
      await axios.delete(`${API_BASE}/deleteNotification/${id}`,{headers:{Authorization: `Bearer ${localStorage.getItem("token")}`}});
      alert("Notification deleted successfully!");
      fetchNotifications();
    } catch (error) {
      console.error("Error deleting notification:", error);
      alert("Failed to delete notification.");
    }
  };

  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      {/* Add Notification Form */}
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col">
            <label className="mb-1 font-semibold">Title</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Notification title"
              className="border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div className="flex flex-col">
            <label className="mb-1 font-semibold">Delete Date</label>
            <input
              type="date"
              value={deleteDate}
              onChange={(e) => setDeleteDate(e.target.value)}
              className="border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div className="flex flex-col md:col-span-2">
            <label className="mb-1 font-semibold">Content</label>
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="Write your notification"
              className="border rounded-lg px-3 py-3 h-28 focus:ring-2 focus:ring-blue-500 resize-none"
              required
            />
          </div>

          <div className="flex flex-col">
            <label className="mb-1 font-semibold">Send To</label>
            <select
              value={sendTo}
              onChange={(e) => setSendTo(e.target.value)}
              className="border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            >
              <option value="students">Students</option>
              <option value="teachers">Teachers</option>
              <option value="both">Both</option>
            </select>
          </div>

          <div className="flex flex-col">
            <label className="mb-1 font-semibold">Attachment (optional)</label>
            <input
              type="file"
              onChange={(e) => setAttachFile(e.target.files[0])}
              className="border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        <div className="flex gap-4 mt-4">
         <button
  type="submit"
  disabled={submitting}
  className={`px-4 py-2 rounded-lg text-white transition
    ${submitting ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"}
  `}
>
  {submitting
    ? "Submitting..."
    : editId
      ? "Update Notification"
      : "Submit Notification"}
</button>


          <button
            type="button"
            onClick={() => {
              setTitle("");
              setContent("");
              setDeleteDate("");
              setSendTo("students");
              setUserId("");
              setAttachFile(null);
            }}
            className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-500"
          >
            Reset
          </button>
        </div>
      </form>

      {/* Notifications List */}
      <h2 className="text-3xl font-bold mt-12 mb-6">Notifications List</h2>
      {loading ? (
        <p>Loading...</p>
      ) : notifications.length === 0 ? (
        <p>No notifications available for this session.</p>
      ) : (
        <div className="space-y-4">
          {notifications.map((n) => (
            <div
              key={n._id}
              className="bg-gray-50 p-4 border rounded-lg flex justify-between items-start"
            >
              <div>
                <h3 className="font-semibold text-lg">{n.title}</h3>
                <p>{n.content}</p>
                <p className="text-sm text-gray-500">
                  Delete Date: {new Date(n.deleteDate).toLocaleDateString()}
                </p>
                {n.attachFile && (
                  <a
                    href={n.attachFile}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline text-sm"
                  >
                    View Attachment
                  </a>
                )}
                <p className="text-sm text-gray-500">
                  Send To: {n.sendTo}
                  {n.sendTo === "user" && n.userId ? ` (User ID: ${n.userId})` : ""}
                </p>
              </div>

              <div className="flex gap-2">
  <button
    onClick={() => handleEdit(n)}
    className="bg-yellow-500 text-white px-3 py-2 rounded hover:bg-yellow-400"
  >
    Edit
  </button>

  <button
    onClick={() => handleDelete(n._id)}
    className="bg-red-600 text-white px-3 py-2 rounded hover:bg-red-500"
  >
    Delete
  </button>
</div>

            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AddNotifications;